import React from 'react';
import { AppBar, Box, Paper, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.outerContainer?.background ?? theme.palette.background.paper,
    boxShadow: theme.palette.innerContainer?.shadow
      ? `0 3px 2px ${theme.palette.innerContainer.shadow}`
      : theme.shadows[2],
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1)
    }
  }
}));

export default function IndexedSettingsTabs({
  items,
  idPrefix,
  renderPanel,
  appBarClassName,
  appBarStyle,
  panelStyle = { padding: 0 },
  contained = false,
  onActiveChange
}) {
  const classes = useStyles();
  const itemIds = items.map((item) => String(item.id));
  const [activeId, setActiveId] = React.useState(itemIds[0] ?? '');

  React.useEffect(() => {
    if (!itemIds.includes(activeId)) {
      setActiveId(itemIds[0] ?? '');
    }
  }, [activeId, itemIds]);

  React.useEffect(() => {
    onActiveChange?.(activeId);
  }, [activeId, onActiveChange]);

  if (items.length === 0) return null;

  const tabs = (
    <TabContext value={activeId}>
      <AppBar position="static" color="default" className={appBarClassName} style={appBarStyle}>
        <Box display="flex" justifyContent="center" width="100%">
          <TabList
            variant="scrollable"
            scrollButtons="auto"
            onChange={(_, value) => setActiveId(value)}
          >
            {items.map((item, index) => {
              const id = String(item.id);
              return (
                <Tab
                  key={id}
                  value={id}
                  label={item.label}
                  id={`${idPrefix}-tab-${index}`}
                  aria-controls={`${idPrefix}-tabpanel-${index}`}
                />
              );
            })}
          </TabList>
        </Box>
      </AppBar>

      {items.map((item, index) => {
        const id = String(item.id);
        return (
          <TabPanel key={id} value={id} id={`${idPrefix}-tabpanel-${index}`} style={panelStyle}>
            {renderPanel(item, index)}
          </TabPanel>
        );
      })}
    </TabContext>
  );

  return contained ? <Paper className={classes.container}>{tabs}</Paper> : tabs;
}
